var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { sendToHost } from 'conversional-iframe-communication';
import ModalDesign from './ModalDesign';
import { onEsc } from '../utils/listener';
import { FULLSCREEN_BODY_ACTIVE_CLASSNAME, FULLSCREEN_BODY_ACTIVE_STYLES, } from './Fullscreen.styles';
/**
 * Fullscreen view adds the necessary controls for a fullscreen display,
 * e.g. closing on ESC and buttons to close and rewind
 */
// TODO: Apply modal frame around rendered content just like today
// TODO: Add iframe controls
// TODO: Add parent style
var Fullscreen = function (_a) {
    var children = _a.children, onClose = _a.onClose, onAnimationComplete = _a.onAnimationComplete, _b = _a.modalProps, modalProps = _b === void 0 ? {} : _b;
    React.useEffect(function () {
        // Exit on press Esc requires focus on iframe
        sendToHost.focusIframe();
        sendToHost.addStylesTagToHost({
            elementId: FULLSCREEN_BODY_ACTIVE_CLASSNAME,
            styles: FULLSCREEN_BODY_ACTIVE_STYLES,
        });
        sendToHost.addClassNameToElements(FULLSCREEN_BODY_ACTIVE_CLASSNAME, ['body', 'html']);
        onEsc(close);
    }, []);
    var close = function () {
        sendToHost.removeClassNameFromElements(FULLSCREEN_BODY_ACTIVE_CLASSNAME, ['body', 'html']);
        sendToHost.blurIframe();
        onClose();
    };
    return (_jsx(ModalDesign, __assign({ onClose: close }, modalProps, { onAnimationComplete: onAnimationComplete, children: children })));
};
export default Fullscreen;
